import {createUseStyles} from "react-jss";
import {colors} from "../../constants/colors";

const styles = createUseStyles((theme) => ({
  loyaltyPageContent: {},
  outerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "12px",
    border: `1px solid ${colors.lightGrey}`,
    padding: "32px 0px 48px 0px",
    margin: "0px"
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "352px"
  },
  loyaltyWelcomeIconContainer: {
    marginBottom: "16px"
  },
  welomeTextTitle: {
    fontWeight: "600",
    textAlign: "center"
  },
  welomeTextDescription: {
    textAlign: "center"
  },
  container: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
  },
  resubmitButton: {
    marginTop: 'auto',
    paddingBottom: 'unset',
    color: colors.mediumGrey
  },
  resubmitButtonContainer: {
    marginLeft: 'auto'
  }
}));

export default styles;